import React, { useEffect, useState } from 'react'
import classNames from 'classnames'

import styles from './CheckboxSwitch.module.scss'

interface Props {
  label?: string
  name: string
  initialValue?: boolean
  readOnly?: boolean
  disabled?: boolean
  onChange: (value: boolean) => void
  className?: string
  'data-test'?: string
}

export const CheckboxSwitch: React.FC<Props> = (props) => {
  const { label, name, initialValue, readOnly, disabled, onChange, className } = props

  const [value, setValue] = useState<boolean>(!!initialValue)

  useEffect(() => {
    setValue(!!initialValue)
  }, [initialValue])

  return (
    <div className={classNames(styles.wrapper, className)}>
      {label && <span>{label}</span>}
      <span className={styles.checkbox}>
        <input
          type='checkbox'
          id={name}
          className={value ? 'checked' : ''}
          checked={value}
          readOnly={readOnly}
          disabled={disabled}
          onChange={(e) => {
            if (readOnly || disabled) {
              return
            }

            setValue(e.target.checked)
            onChange(e.target.checked)
          }}
          data-test={props?.['data-test']}
        />
        <label htmlFor={name} />
        <span className={styles.selector} />
      </span>
    </div>
  )
}
